import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const auditsRouter: RouteConfig = {
  path: '/audits',
  component: Layout,
  redirect: '/audits/auditFlowList',
  name: '审核管理',
  meta: {
    title: '审核管理'
  },
  children: [
    {
      path: 'auditFlowList',
      name: 'auditFlowList',
      component: () => import(/* webpackChunkName: "audit" */ '@/views/audits/auditFlowList.vue'),
      meta: {
        title: '审核流程列表'
      }
    },
    {
      path: 'auditNodePreDefineList',
      name: 'auditNodePreDefineList',
      component: () => import(/* webpackChunkName: "audit" */ '@/views/audits/auditNodePreDefineList.vue'),
      meta: {
        title: '预置审核节点'
      }
    },
    {
      path: 'auditFlowDetail/:hostType/:hostId/:auditFlowId',
      name: 'auditFlowDetail',
      component: () => import(/* webpackChunkName: "audit" */ '@/views/audits/auditFlowDetail.vue'),
      meta: {
        title: '审核信息详情'
      }
    }
  ]
}

export default auditsRouter
